import { supportChatListeners } from "./supportChatListeners";
import { supportTicketsListeners } from "./supportTicketsListeners";

export const attachSocketEvents = (socket, dispatch) => {
  supportChatListeners(socket, dispatch);
  supportTicketsListeners(socket, dispatch);
};
